export default "__VITE_ASSET__f2bc33ea__"